export default "__VITE_ASSET__CrflAKFK__"